// =============================================================================
// Punto d'ingresso UNICO del layer `services/`.
// Riusa l'istanza axios centrale di `lib/api.js` (interceptor Bearer + refresh 401):
// nessuna nuova configurazione, nessun cambio di comportamento.
// =============================================================================
import { api, formatApiError, mediaUrl, tokenStore, API, getWsUrl } from '@/lib/api';

export { api, formatApiError, mediaUrl, tokenStore, API, getWsUrl };

/**
 * Sballa la risposta axios restituendo direttamente `res.data`.
 * Uso: `const rooms = await unwrap(api.get('/hotel/rooms'));`
 * @template T
 * @param {Promise<{ data: T }>} p
 * @returns {Promise<T>}
 */
export const unwrap = (p) => p.then((res) => res.data);
